exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Table-table-lZeph {\r\n  border-right: 1px solid #666;\r\n  border-bottom: 1px solid #666;\r\n  width: 100%;\r\n}\r\n.Table-table-lZeph th,\r\n.Table-table-lZeph td {\r\n  border-left: 1px solid #999;\r\n  border-top: 1px solid #999;\r\n  text-align: center;\r\n  padding: 3px;\r\n}", "", {"version":3,"sources":["E:/dbProject/dbrank_b/src/routes/customChart/Table/Table.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;CACb;AACD;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;CACd","file":"Table.css","sourcesContent":[".table {\r\n  border-right: 1px solid #666;\r\n  border-bottom: 1px solid #666;\r\n  width: 100%;\r\n}\r\n.table th,\r\n.table td {\r\n  border-left: 1px solid #999;\r\n  border-top: 1px solid #999;\r\n  text-align: center;\r\n  padding: 3px;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table": "Table-table-lZeph"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/customChart/Table/Table.css
// module id = 1745
// module chunks = 1